<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.addProofDocument' | translate}}
</kendo-dialog-titlebar>
<form  [formGroup]="addDataForm">
    <app-proof-document-form [form]="addDataForm"></app-proof-document-form>
</form>

<kendo-dialog-actions>
    <button kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
    <button kendoButton (click)="confirm()" [primary]="true" submit>
        <span *ngIf="!editMode">{{'global.add' | translate}}</span>
        <span *ngIf="editMode">{{'global.save' | translate}}</span>
    </button>
</kendo-dialog-actions>
